import React, { useEffect, useState } from 'react'
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import {Toolbar} from '../../layout/Toolbar/Toolbar';
import { EvaluacionesPrecalificacionesPorValidar } from '../../components/Evaluacion/EvaluacionesPrecalificacionesPorValidar';
import { VerEvaluacionesPrecalificacionesFuncionario } from '../../components/Calificaciones/VerEvaluacionesPrecalificacionesFuncionario';
import { ListarPrecalificaciones } from '../../components/EtapasDeCalificacion/ListarPrecalificaciones';
import { InformacionFuncionario } from '../../components/EtapasDeCalificacion/InformacionFuncionario';

export const DetallePrecalificaciones = () => {
    
    const { id_participant } = useParams();
    const user = useSelector(selectUser);
  

    let toolbarEnlaces = [
        {
          muted: "true",
          to: "/",
          title: "Home",
          bullet: "false",
        },
        {
          muted: "true",
          to: "",
          title: "",
          bullet: "true",
        },
        {
          muted: "false",
          to: "/misPrecalificaciones",
          title: "Mis precalificaciones",
          bullet: "false",
        },
      ];

    return (
        <>
        <div
            className="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
            <Toolbar title="Mis Precalificaciones" enlaces={toolbarEnlaces}></Toolbar>
            <div className="post d-flex flex-column-fluid" id="kt_post">
            <div className="container-xxl">
                <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body vh-75">
                            <div className='row'>
                        
                                <InformacionFuncionario
                                id_participant={id_participant}
                                boton_historial={false}
                                ></InformacionFuncionario>

                                <div className='col-md-12'>
                                    <ListarPrecalificaciones
                                    id_participant={id_participant}
                                    ></ListarPrecalificaciones>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </>
    )
    
}
